import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Container } from 'reactstrap';
import { FaCheck } from 'react-icons/fa';
import CommunicationComponent from "../communication/CommunicationComponent";
import Handlebars from "handlebars";

/**
 * Unterpunkte des aktuellen Hauptschritts.
 *
 * Sie sitzen in derselben Leiste wie der Stepper (siehe FormularPage) und
 * gehoeren dort sichtbar zum aktiven Schritt - keine zweite, eigenstaendige
 * Navigationsebene.
 */
class SubNavigation extends CommunicationComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }

    getCategories() {
        return this.props.categories;
    }

    qCtrl() {
        return this.props.qctrl;
    }

    clickOnChildCategory(e, c) {
        this.fireEvent("pageChanged");
        this.qCtrl().setCurrentQuestionPage(c);
    }

    getVisibleChildren() {
        return this.qCtrl().getCurrentSubcategories()
          .filter((c) => this.qCtrl().isVisible(c));
    }

    renderChildCategories(visible) {
        const currentSub = this.qCtrl().getCurrentSubCategory();
        return visible.map((c) => {
            const clickable = this.qCtrl().isClickable(c);
            const answered = this.qCtrl().hasAnswerForQuestionOrPage(c);
            const active = currentSub && currentSub.id == c.id;

            let cls = "wc-sub";
            if (active) {
                cls += " is-active";
            }
            else if (answered) {
                cls += " is-done";
            }
            if (clickable) {
                cls += " is-clickable";
            }

            return <li key={c.id}
                       className={cls}
                       onClick={(e) => (clickable) ? this.clickOnChildCategory(e, c) : null}>
                <span className={"wc-sub-label"}>{this.renderName(c)}</span>
                {answered && <FaCheck size={10} className={"wc-sub-check"} />}
            </li>;
        });
    }

    renderName(c) {
        try {

            const name = c.name;
            const template = Handlebars.compile((name) ? name : "");

            return template({questions: c.elements});
        }
        catch(e) {
            console.error(e);
        }
        return c.name;
    }

    render() {
        const visible = this.getVisibleChildren();
        if (visible.length === 0) {
            return null;
        }

        const currentSub = this.qCtrl().getCurrentSubCategory();
        const position = currentSub
          ? visible.findIndex((c) => c.id == currentSub.id) + 1
          : 0;
        const category = this.qCtrl().getCurrentCategory();

        return <Container fluid={true} className={"subnav"}>
            <div className={"wc-subnav"}>
                <div className={"wc-subnav-status"}>
                    <span className={"wc-subnav-title"}>{category ? category.name : ""}</span>
                    {position > 0 && <span className={"wc-subnav-count"}>
                        {position} von {visible.length}
                    </span>}
                </div>
                <ol className={"wc-subs"}>
                    {this.renderChildCategories(visible)}
                </ol>
            </div>
        </Container>;
    }
};

SubNavigation.propTypes = {

};


export default SubNavigation;
